"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearControl = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../i18n");
var locale_1 = require("../../util/locale");
var Button_1 = require("../Button");
var HFlow_1 = require("../HFlow");
var Icon_1 = require("../Icon");
function YearControl(props) {
    var visibleDate = props.visibleDate, onChange = props.onChange, renderYear = props.renderYear;
    var locale = i18n_1.useLocale();
    var handleNext = function () {
        var next = new Date(visibleDate);
        next.setFullYear(visibleDate.getFullYear() + 1);
        return onChange(next);
    };
    var handlePrev = function () {
        var prev = new Date(visibleDate);
        prev.setFullYear(prev.getFullYear() - 1);
        return onChange(prev);
    };
    return (react_1.default.createElement(HFlow_1.HFlow, { alignItems: 'center', hSpacing: 0.5 },
        react_1.default.createElement(Button_1.Button, { title: locale.calendar.previousYear, size: 'small', skin: 'ghost', onClick: handlePrev, tabIndex: -1 },
            react_1.default.createElement(Icon_1.Icon, { icon: 'angleLeft' })),
        renderYear(visibleDate),
        react_1.default.createElement(Button_1.Button, { title: locale.calendar.nextYear, size: 'small', skin: 'ghost', onClick: handleNext, tabIndex: -1 },
            react_1.default.createElement(Icon_1.Icon, { icon: 'angleRight' }))));
}
exports.YearControl = YearControl;
YearControl.defaultProps = {
    renderYear: function (date) {
        var formatter = new Intl.DateTimeFormat(locale_1.getUserLocale(), { year: 'numeric' });
        return formatter.format(date);
    },
};
//# sourceMappingURL=YearControl.js.map